// extracted by mini-css-extract-plugin
export default {"root":"textarea_root__jm5Cd","skeleton":"textarea_skeleton__YCWdZ","wrapper":"textarea_wrapper__HpSeq","input":"textarea_input__fHZbC"};